import { render } from "./CartComponent.vue?vue&type=template&id=3a145e1e&scoped=true"
import script from "./CartComponent.vue?vue&type=script&lang=js"
export * from "./CartComponent.vue?vue&type=script&lang=js"

import "./CartComponent.vue?vue&type=style&index=0&id=3a145e1e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a145e1e"]])

export default __exports__